module.exports = __webpack_public_path__ + "static/media/contracts.5906d1c2.svg";